import { createSlice } from '@reduxjs/toolkit'
import { Slice } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false
}

const slice = createSlice({
  name: 'customer/subscribe',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function subscribe (email: string): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().customer.subscribe({ email })
      const { data } = response || {}
      const { addNewSubscriber } = data || {}
      const hasStatus = Object.prototype.hasOwnProperty.call(addNewSubscriber, 'status')

      if (hasStatus) {
        dispatch(success())
      } else {
        dispatch(failure())
      }

      return hasStatus
    } catch (e) {
      dispatch(failure())
      return false
    }
  }
}
